import { ASSESSMENT_EVENT_TYPES } from '../../../constants';
import { format } from 'date-fns';

export const displayOpenDate = ({ eventType, currentDate, openDate }) => {
  if (currentDate < openDate && ASSESSMENT_EVENT_TYPES.includes(eventType)) {
    return format(openDate, 'h.mmaaa, EEEE d MMMM yyyy').replace('.00', '');
  }
};
